import { render, staticRenderFns } from "./amount-detail.vue?vue&type=template&id=694fb902"
import script from "./amount-detail.vue?vue&type=script&lang=js"
export * from "./amount-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports